import { FaExclamation } from "react-icons/fa"

const ErrorIcon = () => {
    return (
        <div className="p-16 md:p-[100px] rounded-full bg-[#D80027]/10 max-w-[400px] mx-auto">
            <div className="p-8 md:p-[50px] rounded-full bg-[#D80027]/30">
                <div className="w-14 md:w-[100px] aspect-square flex justify-center items-center rounded-full bg-[#D80027]">
                    <FaExclamation className="text-xl md:text-6xl text-white" />
                </div>
            </div>
        </div>
    )
}

export default ErrorIcon